import {ERASED_FIRSTNAME, ERASED_LASTNAME, isErasedName} from "./erasedRecordMessage";

type PersonName = {firstname?: string | null; lastname?: string | null} | null | undefined;

// "Nachname, Vorname" für die sortierbaren Nachname-zuerst-Spalten, sonst "Vorname Nachname".
// Der Platzhalter der DSGVO-Löschung ist kein Name: immer „Gelöscht (DSGVO)“, nie „(DSGVO), Gelöscht“.
export const formatPersonName = (firstname?: string | null, lastname?: string | null, lastnameFirst?: boolean) => {
    if (isErasedName(firstname, lastname)) return `${ERASED_FIRSTNAME} ${ERASED_LASTNAME}`;

    return lastnameFirst ? [lastname, firstname].filter(Boolean).join(", ") : [firstname, lastname].filter(Boolean).join(" ");
};

// Suche wie findByFullname am Server: mit Komma links Nachname, rechts Vorname;
// ohne Komma muss jedes Wort in Vor- oder Nachname vorkommen (Reihenfolge egal)
export const matchesNameSearch = (searchKey: string, person: PersonName) => {
    const firstname = (person?.firstname ?? "").toLowerCase();
    const lastname = (person?.lastname ?? "").toLowerCase();
    const [lastnamePart, firstnamePart] = searchKey
        .toLowerCase()
        .split(",")
        .map((part) => part.trim().split(/\s+/).join(" "));

    if (firstnamePart !== undefined) {
        return lastname.includes(lastnamePart) && firstname.includes(firstnamePart);
    }

    return lastnamePart
        .split(" ")
        .every((token) => firstname.includes(token) || lastname.includes(token));
};

// Sortierung "Nachname, dann Vorname" — getrennt verglichen, damit "Müller" vor "Müller-Schmidt" steht
export const comparePersonsLastFirst = (a: PersonName, b: PersonName) =>
    (a?.lastname ?? "").localeCompare(b?.lastname ?? "", "de") || (a?.firstname ?? "").localeCompare(b?.firstname ?? "", "de");
